import styled from 'styled-components';

export const CurrentUserStyled = styled.div`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		&:hover {
			cursor: pointer;
			opacity: 0.7;
		}
		gap: 8px;
		display: flex;
		align-items: center;
	}
`;

export const UserNameContainerStyled = styled(`div`)`
	max-width: 150px;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		max-width: 300px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		max-width: 600px;
	}
`;

export const ContainerStyled = styled.div`
	gap: 24px;
	align-items: center;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: none;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: flex;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: flex;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: flex;
	}
`;

export const ButtonContainerStyled = styled.div`
	gap: 24px;
	display: flex;
	align-items: center;
`;

export const UserNameStyled = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 14px;
`;

export const UserAvatarStyled = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
